<template>
    <div>
        <div class="nav-bar">
            <div class="logo">
                <img :src="$global.Image.icon_logo" alt="" />
            </div>
            <div class="con">
                <div v-swiper:mySwiper="swiperOption">
                    <div class="swiper-wrapper">
                        <div
                            class="swiper-slide"
                            v-for="(item, index) in banners"
                            :key="index"
                        >
                            <img :src="item.img" alt="" />
                        </div>
                    </div>
                    <div class="swiper-pagination" slot="pagination"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "../../node_modules/swiper/swiper.less";
export default {
    name: "navBar",
    components: {
        Swiper,
        SwiperSlide
    },
    directives: {
        swiper: directive
    },
    data() {
        return {
            banners: [],
            swiperOption: {
                pagination: {
                    el: ".swiper-pagination"
                }
            }
        };
    },
    methods: {
        swiper() {
            this.$post("/api/Index/banner_list", {
                type: 1
            })
                .then(res => {
                    if (res.code == 1) {
                        this.banners = res.data;
                    }
                })
                .catch(err => {});
        }
    },
    mounted() {
        this.swiper();
        this.mySwiper.slideTo(1, 1000, false);
    }
};
</script>
<style lang="less" scoped>
.nav-bar {
    width: 100%;
    .logo {
        width: 100%;
        height: 80px;
        display: flex;
        align-items: center;
        background: url("../assets/icon/icon_ls.png") no-repeat;
        // background-size: 100% 100%;
        img {
            // width: 180px;
            height: 50px;
            margin-left: 400px;
        }
    }
    .con {
        width: 100%;
        height: 300px;
        img {
            width: 100%;
            height: 300px;
            object-fit: fill;
        }
        .swiper-wrapper {
            width: 100%;
            height: 100%;
        }
    }
    .my-swipe .van-swipe-item {
        color: #fff;
        font-size: 20px;
        line-height: 300px;
        text-align: center;
        background-color: #39a9ed;
    }
}
</style>
